import { render } from "./wistia-video-modal.vue?vue&type=template&id=5244ad77"
import script from "./wistia-video-modal.vue?vue&type=script&lang=js"
export * from "./wistia-video-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__